import loadable from '@loadable/component';

export const CmsViewFilePageLoadable = loadable(
  () => import('./CmsViewFilePage'),
  { resolveComponent: (module) => module.CmsViewFilePage },
);
